import { changePasswordSchema, gridSizeMdLg12, gridSizeMdLg5 } from "@/shared";
import { ChangePasswordData, useChangePassword } from "@/shared/actions/auth";
import { CustomPasswordTextField } from "@/shared/components/ui";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Divider, Grid, Typography } from "@mui/material";
import { useForm } from "react-hook-form";

export default function TabSeguridadPerfil() {
    const setIsGlobalLoading = useUiStore(s=>s.setIsGlobalLoading);
    // const setAlert = useUiStore(s=>s.setAlert);

    const {mutateAsync:updatePasswordMAsync, isPending} = useChangePassword()

    const formUpdatePassword = useForm<ChangePasswordData>({
        resolver: yupResolver(changePasswordSchema)
    });
    const {
        handleSubmit,
        formState: { errors },
    } = formUpdatePassword;

    const handleUpdatePassword = async() =>{
        const data = formUpdatePassword.getValues()
        const res = await updatePasswordMAsync(data)
        console.log({vamos:res})
        formUpdatePassword.reset()
    }
    
    
    
    setIsGlobalLoading(isPending)
    return (
    <Grid container item {...gridSizeMdLg12}>
        <Grid item>
            <Divider/>
            <Grid container item gap={2} spacing={2} pb={2}>
                {/* <TabTextLabel pl={2} text="Cambiar Contraseña"/> */}
                <Grid item gap={2}>
                    <Typography variant="h6" py={2}>Actualizar contraseña</Typography>
                </Grid>
                <Grid container item gap={2} spacing={2}>
                    <CustomPasswordTextField
                        label="Contraseña Anterior"
                        name="old_password"
                        size={gridSizeMdLg5}
                        errors={errors}
                        form={formUpdatePassword}
                        enableToSubmitWithEnter={true}
                    />
                    <CustomPasswordTextField
                        label="Contraseña Nueva"
                        name="password"
                        size={gridSizeMdLg5}
                        errors={errors}
                        form={formUpdatePassword}
                        enableToSubmitWithEnter={true}
                    />
                </Grid>
                <Grid item>
                    <Button
                        variant="outlined"
                        sx={{
                            py: 1,
                            my: 0,
                            marginX:1
                        }}
                        size="small"
                        onClick={handleSubmit(handleUpdatePassword, () => {
                            console.log("problemas")
                            // setAlert(true, "Faltan campos por llenar", "error");
                        })}
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>
            <Divider/>
        </Grid>
    </Grid>
  )
}
